
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { ModuleItemProps } from ".";
import { loading, create } from "store/module";
import { AppMessage } from "components";

interface ApiModuleCreateInputProps extends Omit<ModuleItemProps, "id"> {
}

type ApiModuleCreateOutputProps = OutputBaseProps<{ item: ModuleItemProps; }, ApiModuleCreateInputProps>

export const apiModuleCreate = async (data: ApiModuleCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiModuleCreateOutputProps>("/api/module/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};